module.exports = __webpack_public_path__ + "img/ai01.d9a195a9.svg";